import React from "react";
import { hydrate } from "react-dom";
import { createBrowserHistory } from "history";
import axios from "axios";
import Providers from "./components/providers";
import unauthorizedResponseInterceptor from "./unauthorized-response-interceptor";
import App from "../universal/components/app";
import { REQUEST_ORIGINATION_HEADER } from "../constants";
import createStore from "../universal/store/create-store";
import axiosProvider from "../universal/utils/axios-provider/axios-provider";
import cssVarsPonyfill from "css-vars-ponyfill";

/* Google Fonts */
import "typeface-open-sans";

const renderClient = async () => {
  const history = createBrowserHistory();
  const store = createStore(history, window.__INITIAL_STATE__);
  const {
    paths: { publicApi }
  } = store.getState();

  //This header will allow personaluser-edge to track consumers
  axios.defaults.headers.common[REQUEST_ORIGINATION_HEADER.HEADER_NAME] =
    REQUEST_ORIGINATION_HEADER.HEADER_VALUE;

  // initialize the axiosProvider to return the global axios instance
  axiosProvider.init(() => axios);

  cssVarsPonyfill({
    onBeforeSend(xhr) {
      // IE cache breaks ponyfill
      xhr.setRequestHeader("Cache-Control", "no-cache");
      xhr.setRequestHeader("Pragma", "no-cache");
      xhr.setRequestHeader("Expires", "-1");
    }
  });

  unauthorizedResponseInterceptor(publicApi);

  hydrate(
    <Providers store={store} history={history}>
      <App />
    </Providers>,
    document.getElementById("root")
  );
};

export default renderClient;
